export const CURRENT_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://dev.backend.sepaheld.com/api";

const configurations = {
    development: {
        registerPricingTableId: process.env.REACT_APP_STRIPE_REGISTER_PRICING_TABLE_ID || 'prctbl_1OTrdIBfaexXG5Y7OSyiJygx',
        registerPublishableKey: process.env.REACT_APP_STRIPE_REGISTER_PUBLISHABLE_KEY || 'pk_test_51I1AkuBfaexXG5Y712F1vcprZJfc9MBRoyaCnrAApOyje68ql1UCo1lCaQ4wK3s8gwOdkwgo89HPS5YeADWSoAJ700DtlBIpv7',
        upgradePremiumPricingTableId: process.env.REACT_APP_STRIPE_UPGRADE_PRICING_TABLE_ID || 'prctbl_1P3yL5BfaexXG5Y7841KGLvJ',
        upgradePremiumPublishableKey: process.env.REACT_APP_STRIPE_UPGRADE_PUBLISHABLE_KEY || 'pk_test_51I1AkuBfaexXG5Y712F1vcprZJfc9MBRoyaCnrAApOyje68ql1UCo1lCaQ4wK3s8gwOdkwgo89HPS5YeADWSoAJ700DtlBIpv7',
        discountCodeAnnuallyStandard: process.env.REACT_APP_DISCOUNT_CODE_ANNUALLY || '4NxfGNOd',
        discountCodeUpgradePremium: process.env.REACT_APP_DISCOUNT_CODE_UPGRADE || 'SEPAHELD2024',
        gocardlessVerificationUrl: process.env.REACT_APP_GOCARDLESS_VERIFICATION_URL || 'https://verify-sandbox.gocardless.com',
        xentralDomainSuffix: process.env.REACT_APP_XENTRAL_DOMAIN_SUFFIX || 'demo.xentral.com',
        wisomeinbueroConnectUrl: process.env.REACT_APP_WISOMEINBUERO_CONNECT_URL || 'https://app.meinbuero.de/apps/published',
        invoizConnectUrl: process.env.REACT_APP_INVOIZ_CONNECT_URL || 'https://app.invoiz.de/apps/published'
    },
    production: {
        registerPricingTableId: process.env.REACT_APP_STRIPE_REGISTER_PRICING_TABLE_ID || 'prctbl_1PIrIQBfaexXG5Y7x2C43tUJ',
        registerPublishableKey: process.env.REACT_APP_STRIPE_REGISTER_PUBLISHABLE_KEY || 'pk_live_51I1AkuBfaexXG5Y7NHExTiVDno6nW5JuTEBvsl1MuIyW809rbVio4jGqo2PokmXpkxLmbi5yb4FEQSvogHFbL1P7007X1FBSBQ',
        upgradePremiumPricingTableId: process.env.REACT_APP_STRIPE_UPGRADE_PRICING_TABLE_ID || 'prctbl_1PIrVmBfaexXG5Y7yXWi9ktO',
        upgradePremiumPublishableKey: process.env.REACT_APP_STRIPE_UPGRADE_PUBLISHABLE_KEY || 'pk_live_51I1AkuBfaexXG5Y7NHExTiVDno6nW5JuTEBvsl1MuIyW809rbVio4jGqo2PokmXpkxLmbi5yb4FEQSvogHFbL1P7007X1FBSBQ',
        discountCodeAnnuallyStandard: process.env.REACT_APP_DISCOUNT_CODE_ANNUALLY || 'TJOAKNUM',
        discountCodeUpgradePremium: process.env.REACT_APP_DISCOUNT_CODE_UPGRADE || 'SEPAHELD2024',
        gocardlessVerificationUrl: process.env.REACT_APP_GOCARDLESS_VERIFICATION_URL || 'https://verify.gocardless.com',
        xentralDomainSuffix: process.env.REACT_APP_XENTRAL_DOMAIN_SUFFIX || 'xentral.biz',
        wisomeinbueroConnectUrl: process.env.REACT_APP_WISOMEINBUERO_CONNECT_URL || 'https://app.meinbuero.de/apps/published',
        invoizConnectUrl: process.env.REACT_APP_INVOIZ_CONNECT_URL || 'https://app.invoiz.de/apps/published'
    },
};

const publicMandateApiDocsAuth = {
    username: process.env.REACT_APP_API_DOCS_USERNAME || "swagger",
    password: process.env.REACT_APP_API_DOCS_PASSWORD || "",
    url: "/v3/api-docs/public-api"
};

const env = process.env.NODE_ENV || 'development';

const configToUse = CURRENT_BASE_URL.includes('dev.backend.sepaheld.com') ? 'development' : 'production';

const config = {
    API_BASE_URL: CURRENT_BASE_URL + '/',
    env,
    params: configurations[configToUse],
    publicMandateApiDocsAuth
};

// Google Tag Manager (GA4 + CookieYes banner), same container as sepaheld.com.
// Only loaded on these hosts, so local builds never send analytics data.
export const GTM_CONFIG = {
    containerId: 'GTM-PBZQLQJD',
    hosts: ['app.sepaheld.com', 'dev.sepaheld.com'],
};

export const XENTRAL_DOMAIN_SUFFIX = configurations[configToUse].xentralDomainSuffix;

export function resolveApiUrl(apiResourcePath) {
    if (apiResourcePath.startsWith('/')) {
        apiResourcePath = apiResourcePath.substring(1);
    }
    return config.API_BASE_URL + apiResourcePath;
}

export default config;
